import React, { Component } from 'react';
import Bugsnag from '../../helpers/bugsnag';

class ClearDersFields extends Component {
  _onClickYes = () => {
    const { onClear, value } = this.props;
    try {
      onClear(value);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="clearDersFieldsModal"
        tabIndex="-1" aria-labelledby="clearDersFieldsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p className="mb-0">This will clear all fields in this section. Continue?</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">No</button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-gray w-100"
                    onClick={this._onClickYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClearDersFields;
